<template>
  <div
    :data-refapp-tagging-id="taggingId"
    :class="['ra-banner__single', `ra-banner__single--${displayMode}`, `shape--${shape}`]"
  >
    <img :src="image.src" :alt="image.alt" class="ra-banner__single-image" />
    <div :class="`ra-banner__single-content content--${alignment}`">
      <div :class="`ra-banner__single-text text--${alignment}`">
        <div v-if="badge" class="ra-banner__badge" v-html="badge"></div>
        <component :is="heading" v-if="title" class="ra-banner__title">{{ title }}</component>
        <div v-if="description" class="ra-banner__desc" v-html="description"></div>
      </div>
      <a
        v-if="cta?.href"
        :href="cta.href"
        class="ra-banner__link"
        :data-refapp-tagging-target="taggingTarget"
      >
        {{ cta.text }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'refapp-banner-base-single',
  inject: [
    'alignment',
    'shape',
    'badge',
    'cta',
    'description',
    'displayMode',
    'heading',
    'image',
    'taggingId',
    'taggingTarget',
    'title',
  ],
};
</script>
